<template>
  <v-dialog v-if="show" v-model="show" light persistent width="75%">
    <v-card color="secondary">
      <v-card-title>
        <div>
          <h5 class="headline font-weight-bold pb-2">
            {{ $t("coverageCeilings.previousMonthsDialog.title") }}
          </h5>
          <p class="subtitle-1 font-weight-medium card-text-color font-regular">
            {{ $t("coverageCeilings.previousMonthsDialog.subtitle") }}
          </p>
        </div>
      </v-card-title>
      <v-card-text>
        <v-row no-gutters align="center">
          <v-col
            class="month-flex"
            v-for="coverage in getPreviousMonths"
            :key="`${coverage.month}-${coverage.year}`"
          >
            <v-card
              class="month-tile text-center pa-2"
              flat
              :class="{ covered: coverage.covered }"
            >
              <v-row no-gutters justify="center">
                <!-- <span v-if="coverage.covered" class="pt-1">
                  <template v-for="(item, i) in coverage.codicePacchetto">
                    <v-tooltip
                      :key="i"
                      top
                      content-class="portal-tooltip-inverted"
                    >
                      <template v-slot:activator="{ on }">
                        <img v-on="on" :src="getCoperturaImg(item)" alt />
                      </template>
                      <span>{{ $t(`codicePacchetto.${item}`) }}</span>
                    </v-tooltip>
                  </template></span
                > -->
                <div class="font-weight-bold mr-2 custom-text">
                  {{ getFullDate(coverage) | titlecase }}
                </div>
                <v-icon color="primary" small v-if="!coverage.covered"
                  >fas fa-times-circle</v-icon
                >
                <v-icon color="white" small v-else>done</v-icon>
              </v-row>
            </v-card>
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          rounded
          class="ml-2"
          color="primary"
          depressed
          @click="show = false"
          >{{ $t("exit") }}</v-btn
        >
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import dayjs from "dayjs";

export default {
  props: {
    visible: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      feImg: require("@/restricted-library/assets/images/w_fe_logo.png"),
      usImg: require("@/restricted-library/assets/images/w_us_logo.svg"),
      mhImg: require("@/restricted-library/assets/images/w_mh_logo.svg"),
      saImg: require("@/restricted-library/assets/images/w_sa_logo.png")
    };
  },
  computed: {
    show: {
      get() {
        return this.visible;
      },
      set(value) {
        if (!value) {
          this.$emit("close");
        }
      }
    },
    getPreviousMonths() {
      return this.$store.getters["coverages/getPreviousMonths"];
    }
  },
  methods: {
    getFullDate(coverage) {
      return dayjs(`${coverage.year}-${coverage.month}-01`).format("MMMM YYYY");
    },
    getCoperturaImg(pacchetto) {
      if (pacchetto === "U1") {
        return this.usImg;
      }
      if (pacchetto === "MH") {
        return this.mhImg;
      }
      if (pacchetto === "SANI") {
        return this.saImg;
      }
      return this.feImg;
    }
  }
};
</script>

<style scoped>
img {
  margin-right: 4px;
  margin-left: 0px;
  height: 15px;
  width: 15px;
}
.month-flex {
  min-width: 250px;
  max-width: 250px;
}
.month-tile {
  color: var(--primary);
  font-size: 14px;
  font-weight: bolder;
  margin: 0 5px 5px 0;
  padding: 5px 10px;
  border-radius: 2px;
}
.month-tile.covered {
  color: white;
  background: var(--primary);
  border-radius: 4px;
  text-align: start;
}
.custom-text {
  padding-top: 2px !important;
}
</style>
